module.exports = __webpack_public_path__ + "img/polnareff-2024.eaad84d8.jpg";